import bearFactory, { ContextDeferredAuthProvider } from "@gooddata/sdk-backend-bear";
import { GD_DOMAIN } from "../global/constants";

const backend = bearFactory()
    .onHostname(GD_DOMAIN)
    .withAuthentication(new ContextDeferredAuthProvider());

export { backend };
